import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { memo, useCallback, useMemo, useState } from "react";
import MainApi from "../../../../../../services/mainApi.service";
import { Box, Chip } from "@mui/material";
import { useParams } from "react-router-dom";
import { Table } from "@4uhub/lib4uhub";
import { IAutomationTasyOrientation } from "../../../../../../models/automation_tasy_orientation";
import { AutomationTasyOrientation } from "./AutomationTasyOrientationForm/AutomationTasyOrientation";

const TICKET_AUTOMATION_TASY_ORIENTATION_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationTasyOrientation/";
const ticketAutomationService = new MainApi<IAutomationTasyOrientation>(
  TICKET_AUTOMATION_TASY_ORIENTATION_ROUTE
);

const translationPath = "chatBot.page.automations.AutomationTasyOrientation.";

export const AutomationTasyOrientationPage = memo(() => {
  const [timeRuleForm, setTimeRuleForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const { id } = useParams();

  const columns: GridColDef<IAutomationTasyOrientation>[] = [
    {
      field: "sendWhen",
      maxWidth: 150,
      headerName: t(translationPath + "send_when") || "Automation Send When",
      renderCell: (params) => params.row.sendWhen.name,
    },
    {
      field: "typeTasyOrientation",
      headerName:
        t(translationPath + "type_tasy_orientation") || "Type Tasy Orientation",
      renderCell: (params) => params.row.typeTasyOrientation.name,
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 120,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleAdd = () => {
    setTimeRuleForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<IAutomationTasyOrientation>
  ) => {
    if (!params.row) return;
    setTimeRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTimeRuleForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      TicketAutomationRuleId: id,
    };
  }, [id]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {timeRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <AutomationTasyOrientation
            id={selectedId}
            ticketAutomationRuleId={id}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!timeRuleForm && (
        <Box height={600}>
          <Table<IAutomationTasyOrientation>
            showDefaultMacroFilters={false}
            service={ticketAutomationService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add") || "Add Automation Tasy Orientation"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
